module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"addTimeSlot":"Zeit hinzufügen","evenWeeks":"Gerade Wochen","from":"von","hours":"Öffnungszeiten","oddWeeks":"Ungerade Wochen","pending":"Ausstehend","title":"Titel","to":"bis"},"en":{"addTimeSlot":"Add time slot","evenWeeks":"Even weeks","from":"from","hours":"Hours","oddWeeks":"Odd weeks","pending":"Pending","title":"Title","to":"to"}}')
  delete Component.options._Ctor
}
